import { render, staticRenderFns } from "./v-aside.vue?vue&type=template&id=11bb8795&scoped=true&"
import script from "./v-aside.vue?vue&type=script&lang=js&"
export * from "./v-aside.vue?vue&type=script&lang=js&"
import style0 from "./v-aside.vue?vue&type=style&index=0&id=11bb8795&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11bb8795",
  null
  
)

export default component.exports